<div class="video-store-login-page">
  <app-topnav></app-topnav>

  <div class="video-store-login-top-spacer"></div>
  <div class="content video-store-login-main video-store-login-container">
    <div class="video-store-login-content">
      <div class="video-store-login-hero">
        <div class="video-store-login-columns">
          <section class="video-store-login-image video-store-login-about video-store-login-hero__program" aria-labelledby="video-login-program-heading">
            <h2 id="video-login-program-heading" class="visually-hidden">BounceBack program</h2>
            <div class="program-intro-card program-intro-card--unified">
              <div class="program-intro-card__top">
                <div class="program-intro-card__main">
                  <div class="program-intro-card__visual">
                    <img src="assets/splash_bilingual.png" class="main-banner program-intro-card__splash" alt="">
                  </div>
                  <div class="program-intro-card__copy">
                    <div class="bb-video-intro-bilingual">
                      @if (!showFrenchIntro) {
                        <section class="login-panel-card video-store-intro-panel" lang="en" aria-labelledby="bounceback-intro-heading-en">
                          <div class="login-panel-card__header">
                            <div class="panel-heading panel-heading--intro" id="bounceback-intro-heading-en">
                              <img src="assets/BounceBack-EN2.png" alt="BounceBack" class="intro-card__brand">
                            </div>
                          </div>
                          <div class="login-panel-card__body">
                            <p class="intro-card__text">{{'bounceBackIntroEnglishText'|translate:translation}}</p>
                          </div>
                        </section>
                      }
                      @if (showFrenchIntro) {
                        <section class="login-panel-card video-store-intro-panel" lang="fr" aria-labelledby="bounceback-intro-heading-fr">
                          <div class="login-panel-card__header">
                            <div class="panel-heading panel-heading--intro" id="bounceback-intro-heading-fr">
                              <img src="assets/BounceBack-FR3.png" alt="Retrouver son entrain" class="intro-card__brand">
                            </div>
                          </div>
                          <div class="login-panel-card__body">
                            <p class="intro-card__text">{{'bounceBackIntroFrenchText'|translate:translation}}</p>
                          </div>
                        </section>
                      }
                    </div>
                  </div>
                </div>

                <aside class="video-store-login-form video-store-login-form--embedded login-panel program-intro-card__signin" aria-labelledby="video-login-signin-heading">
                  <div class="login-panel-card">
                    <div class="login-panel-card__header">
                      <div class="panel-heading panel-heading--signin" [hidden]="!showLoginForm" id="video-login-signin-heading">
                        {{'signInHereText'|translate:translation }}
                      </div>
                      <div class="panel-heading panel-heading--signed-in" [hidden]="showLoginForm">
                        {{'alreadyLoggedInText'|translate:translation}}
                      </div>
                    </div>
                    <div class="login-panel-card__body">
                      <div class="panel-body" [hidden]="!showLoginForm">
                        <p class="video-store-login-scope-notice">{{'loginProvinceScopeNotice'|translate:translation}}</p>
                        <div class="login-field login-field--email">
                          <label class="login-field__label" for="email">{{'emailIdLoginFormText'|translate:translation}}</label>
                          <div class="login-field__input-wrap">
                            <span class="login-field__icon" aria-hidden="true"><i class="fa fa-envelope-o"></i></span>
                            <input type="email" id="email" name="email" class="form-control" [(ngModel)]="loginModel.email" [placeholder]="('emailPlaceholder' | translate : translation)" required="" autocomplete="email">
                          </div>
                        </div>
                        <div class="login-field login-field--code">
                          <label class="login-field__label" for="login-token">{{'loginCodeText'|translate:translation}}</label>
                          <div class="login-field__input-wrap">
                            <span class="login-field__icon" aria-hidden="true"><i class="fa fa-key"></i></span>
                            <input type="password" id="login-token" name="token" class="form-control" [(ngModel)]="loginModel.provinceCode" [placeholder]="('loginCodePlaceholder' | translate : translation)" required="" autocomplete="current-password">
                          </div>
                        </div>
                        <div class="login-actions">
                          <button type="button" class="btn btn-sm video-store-login-button btn-signin-full" (click)="loginWithProvinceCode()"><i class="fa fa-sign-in" aria-hidden="true"></i><span>{{'signinText'|translate:translation}}</span></button>
                        </div>
                      </div>

                      <div class="panel-body panel-body--logged-in" [hidden]="showLoginForm">
                        <label>{{'loggedInAsText'|translate:translation}}: {{this.username}}</label>
                      </div>

                      <div class="video-store-login-error" [class.hide]="!showError" role="alert" [attr.aria-live]="showError ? 'polite' : null">
                        {{'invalidCredentialsText'|translate:translation}}
                      </div>
                    </div>
                  </div>
                </aside>
              </div>

              <div class="program-intro-card__orgs video-store-login-partners video-store-login-partners--in-unified-card" aria-labelledby="video-store-partners-heading">
                <div class="video-store-login-partners__intro">
                  <p id="video-store-partners-heading" class="video-store-login-partners__heading">{{'videoStorePartnersHeading' | translate : translation}}</p>
                </div>
                <div class="video-store-login-logos-row partner-logos-scroll intro-cmha-logo partner-logos-strip partner-logos-strip--wide program-intro-card__logos" role="list" aria-labelledby="video-store-partners-heading">
                  <div class="partner-logo-slot logo-batch" role="listitem">
                    <img src="assets/CMHABC.jpg" alt="CMHA BC">
                  </div>
                  <div class="partner-logo-slot logo-batch logo-batch--single" role="listitem">
                    <img src="assets/CMHA-MBWPG.png" class="other-logos" alt="">
                  </div>
                  <div class="partner-logo-slot logo-batch logo-batch--single" role="listitem">
                    <img src="assets/CMHA_ON.png" class="other-logos" alt="">
                  </div>
                  <div class="partner-logo-slot logo-batch logo-batch--single" role="listitem">
                    <img src="assets/IERHA.gif" class="other-logos" alt="">
                  </div>
                  <div class="partner-logo-slot logo-batch logo-batch--single" role="listitem">
                    <img src="assets/ON_POS_LOGO_RGB.png" class="other-logos" alt="">
                  </div>
                  <div class="partner-logo-slot logo-batch logo-batch--single" role="listitem">
                    <img src="assets/WRHA.gif" class="other-logos" alt="">
                  </div>
                  <div class="partner-logo-slot logo-batch logo-batch--single" role="listitem">
                    <img src="assets/ACSM FR.png" class="other-logos" alt="">
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
